import React, { useEffect } from 'react'
import UserLayout from '../../components/layouts/UserLayout'
import DataTable from '../../components/elements/DataTable'
import { tableHeadersFields, transactionTimeStamp } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPayments } from '../../store/actions/paymentsActions'
import Loader from '../../components/elements/Loader'
import EmptyState from '../../components/elements/EmptyState'
import PaymentStatus from '../../components/elements/PaymentStatus'
import { useState } from 'react'
// import ArrowIcon from '../../components/elements/icons/ArrowIcon'
// import axios from 'axios'
// import { ERROR } from '../../store/types'
// import { useNavigate } from 'react-router-dom'
// import ArrowIcon from '../../components/elements/icons/ArrowIcon'
// import axios from 'axios'
// import { ERROR } from '../../store/types'
// import { useNavigate } from 'react-router-dom'

const Payments = () => {
    const dispatch = useDispatch()
    const paymentsSelector = useSelector((state => state.payments))
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    // const navigate = useNavigate()
    // const navigate = useNavigate()

    useEffect(() => {
        dispatch(fetchPayments('', page, perPage))
        
        return () => {
            
        };

    }, [dispatch, page, perPage]);

    const tableOptions = {
        selectable: false,
        expandable: false,
        clickableRows: false,
        rowAction: (value)=>{}
    }

    const columnWidths = {
        transactionReference: "w-full lg:w-2/12",
        paymentFor: "w-full lg:w-3/12",
        amount: "w-full lg:w-2/12",
        status: "w-full lg:w-1/12",
        date: "w-full lg:w-2/12",
        '': "w-full lg:w-2/12",
    }

    // const [applyingPayment, setApplyingPayment] = useState(null);
    // const [applyingPayment, setApplyingPayment] = useState(null);

    // const applyPayment = async (id) => {
    //     if(window.confirm("This payment will be applied and you can proceed with the action you paid for. Please confirm to continue.")){
    //         try {
    //             const headers = authHeader()
    //             setApplyingPayment(id)
    //             const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/payments/apply/${id}`, { headers })   
    //             setApplyingPayment(null)
    // const applyPayment = async (id) => {
    //     if(window.confirm("This payment will be applied and you can proceed with the action you paid for. Please confirm to continue.")){
    //         try {
    //             const headers = authHeader()
    //             setApplyingPayment(id)
    //             const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/payments/apply/${id}`, { headers })   
    //             setApplyingPayment(null)
                        
    //             if(response.data.data.action === 'start-application'){
    //                 navigate(`/user/applications/new-application/${response.data.data.admission}}?application=${response.data.data.application}`)
    //             }
    //             if(response.data.data.action === 'admit-student'){
    //                 navigate(`/user/students/student/${response.data.data.student}`)
    //             }
    //             if(response.data.data.action === 'start-application'){
    //                 navigate(`/user/applications/new-application/${response.data.data.admission}}?application=${response.data.data.application}`)
    //             }
    //             if(response.data.data.action === 'admit-student'){
    //                 navigate(`/user/students/student/${response.data.data.student}`)
    //             }


    //         } catch (error) {
    //             console.log(error)
    //             dispatch({
    //                 type: ERROR,
    //                 error
    //             })
    //             setApplyingPayment(null)
    //         }
    //     }
    // }
    //         } catch (error) {
    //             console.log(error)
    //             dispatch({
    //                 type: ERROR,
    //                 error
    //             })
    //             setApplyingPayment(null)
    //         }
    //     }
    // }

    const cleanupData = (dataSet) => {
        const data = []
        if (!dataSet) return []

        dataSet.forEach((item, itemIndex) => {
            data.push({
                transactionReference: item.transaction.transactionReference,
                paymentFor: item?.fee?.name || <p>{item?.invoiceAssignment?.invoiceName} ({item.invoiceAssignment?.invoiceCode})</p>,
                amount: <p>₦{
                    // (item?.fee?.amount/100)?.toLocaleString() || 
                    (item?.transaction?.amount/100)?.toLocaleString() || 0}</p>,
                paymentFor: item?.fee?.name || <p>{item?.invoiceAssignment?.invoiceName} ({item.invoiceAssignment?.invoiceCode})</p>,
                amount: <p>₦{
                    // (item?.fee?.amount/100)?.toLocaleString() || 
                    (item?.transaction?.amount/100)?.toLocaleString() || 0}</p>,
                status: <PaymentStatus status={item?.transaction?.status} />,
                date: `${transactionTimeStamp(item.createdAt).date} - ${transactionTimeStamp(item.createdAt).time}`,
                '': item.applied ? 
                    <> 
                        <span className={`inline-block text-xs px-2 py-1 rounded bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize`}>Used</span>
                    </> 
                    : 
                    <div className='flex items-center gap-x-[5px]'>
                        <span className={`inline-block text-xs px-2 py-1 rounded bg-green-500 text-green-800 bg-opacity-10 font-outfit capitalize`}>Unused</span>
                        {/* <button 
                        {/* <button 
                            onClick={()=>{applyPayment(item._id)}} 
                            className='flex items-center gap-x-[5px] bg-green-600 p-[5px] rounded transition duration-200 text-white hover:bg-green-800'
                            disabled={applyingPayment === item._id}
                        >
                            {applyingPayment === item._id ? 
                                'Using payment...' 
                                : 
                                <span className='flex items-center gap-x-[5px]'>
                                    Use Payment<ArrowIcon className={`w-4 h-4`} />
                                </span>
                            }
                        </button> */}
                    </div>

            })
        })

        return data
    }
    
    return (
        <UserLayout>
            <div className='my-12'>
                <div className='mb-8'>
                    <h3 className='text-lg font-medium'>Payments <span className='px-[8px] py-[3px] font-[500] bg-gray-100 rounded text-gray-500 text-xs'>{paymentsSelector.payments.total} items</span></h3>
                    <p className='text-sm mt-2'>List of all payments you have made to Vaatia College</p>
                </div>

                    {paymentsSelector.payments.loadingPayments ?
                        <Loader />
                        :
                        <>
                            {paymentsSelector?.payments?.payments?.length > 0 ?
                                <>
                                    <div className='hidden lg:block w-full'>
                                        <DataTable
                                            tableHeaders={tableHeadersFields(cleanupData(paymentsSelector.payments.payments)[0]).headers} 
                                            tableData={cleanupData(paymentsSelector.payments.payments)} 
                                            columnWidths={columnWidths}
                                            columnDataStyles={{}}
                                            allFields={tableHeadersFields(cleanupData(paymentsSelector.payments.payments)[0]).fields}
                                            onSelectItems={()=>{}}
                                            tableOptions={tableOptions}
                                            pagination={{
                                                currentPage: page,
                                                perPage: perPage,
                                                totalItems: paymentsSelector.payments.total,
                                            }}
                                            changePage={(page)=>{setPage(page)}}
                                            updatePerPage={(perPage)=>{setPerPage(perPage)}}
                                            expandedIndex={''}
                                            expansion={null}
                                        />
                                    </div> 
                                    <div className='lg:hidden w-full'>
                                        {paymentsSelector.payments.payments.map((payment, paymentIndex) => (
                                            <div key={paymentIndex} className='p-[20px] rounded-[16px] border my-[20px] shadow-xl shadow-black/5 relative'>
                                                <span className='absolute top-[20px] right-[20px]'>
                                                    <PaymentStatus status={payment?.transaction?.status} />
                                                </span>

                                                {payment.applied ? 
                                                <> 
                                                    <span className={`absolute bottom-[20px] right-[20px] inline-block text-xs px-2 py-1 rounded bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize`}>Used</span>
                                                </> 
                                                : 
                                                <>
                                                    <span className={`absolute bottom-[20px] right-[20px] inline-block text-xs px-2 py-1 rounded bg-green-500 text-green-800 bg-opacity-10 font-outfit capitalize`}>Unused</span>
                                                </>}
                                                <p className='uppercase tracking-[0.2em] text-[13px] text-vcm-purple'>REF: {payment.transaction.transactionReference}</p>
                                                <h3 className='text-xl text-black font-[550] mb-1'>₦{(payment?.fee?.amount/100).toLocaleString() || '0'}</h3>
                                                <p className='text-sm'>{payment?.fee?.name || ''}</p>
                                                <p className='uppercase tracking-[0.2em] text-[12px] text-vcm-purple mt-4'>{`${transactionTimeStamp(payment.createdAt).date} - ${transactionTimeStamp(payment.createdAt).time}`}</p>
                                                
                                            </div>
                                        ))}
                                    </div> 
                                </>
                            : 
                            <EmptyState emptyStateText={`You have not made any payments yet!`} />
                            }
                        </>
                    }

              </div>
        </UserLayout>
    )
}

export default Payments